import React from "react";
import { NavLink } from "react-router-dom";
import "../css/Sidebar.css";

const Sidebar = () => {
  return (
    <aside className="sidebar">
      <h2 className="sidebar-title">Admin Panel</h2>

      <nav className="sidebar-nav">
        <NavLink to="/dashboard" className="nav-link">
          Dashboard
        </NavLink>

        <NavLink to="/activate-users" className="nav-link">
          Activate Users
        </NavLink>

        <NavLink to="/manage-users" className="nav-link">
          Manage Users
        </NavLink>

        <NavLink to="/Orders" className="nav-link">
          Orders
        </NavLink>
      </nav>
    </aside>
  );
};

export default Sidebar;
